import { useState } from 'react';

const useSearch = ({ jobTitle = [] }) => {
  const [search, setSearch] = useState('');

  const jobTitleFilters = jobTitle.filter(field =>
    field.name?.toLowerCase().startsWith(search.toLowerCase())
  );

  return { setSearch, jobTitleFilters };
};

export default useSearch;
